import React from 'react';

function PageError(): JSX.Element {
    return (
        <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <p>Há problemas com a sua conta.</p>
            <small>Não estamos conseguindo acessar os dados da sua conta e empresa.</small>
        </div>
    );
}

export default PageError;
